module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8593/img/mobile-onboarding-powering-up.svg"